// extracted by mini-css-extract-plugin
export default {"paper":"classes_paper__GlRRx","title":"classes_title__jp4YJ"};